import React from "react";

const ShieldIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M15.9993 12V16M15.9993 16V20M15.9993 16H19.9993M15.9993 16H11.9993M15.9993 28C15.9993 28 25.3327 24 25.3327 18.6667V6.66667C23.3327 6.88889 18.666 6.66667 15.9993 4C13.3327 6.66667 8.66602 6.88889 6.66602 6.66667V18.6667C6.66602 24 15.9993 28 15.9993 28Z"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ShieldIcon;
